import OriginalNavLink from 'reactstrap/es/NavLink';

import { Link } from 'react-router-dom';

function NavLink (props) {
	return (
		<Link to={props.to}>
			<OriginalNavLink {...props}>
				{props.children}
			</OriginalNavLink>
		</Link>
	);
}

export { NavLink };
